<ng-container *ngIf="isLoading">
    <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="!isLoading">
    <!-- Main Project Section -->
    <section class="main-project-section pt-md-4 ps-md-3">
        <div class="px-lg-0 mx-3 mx-md-5" [ngClass]="breadcrumbData?.length > 0 && category_key ? 'breadcrum-border-bottom breadcrum-border-top' : 'breadcrum-border-top'">
            <!-- Breadcrumb -->
            <app-breadcrumb *ngIf="category_key" [breadcrumbData]="breadcrumbData"></app-breadcrumb>
        </div>
    </section>
    <!-- Product Section -->
    <section class="py-2 pt-lg-4 product-section">
        <div class="container-fluid">
            <div class="row gx-xl-4">
                <!-- Tabs -->
                <ng-container *ngIf="productVideo?.length > 0">
                    <ul class="nav product-media-tabs mb-1" role="tablist">
                        <li class="nav-item">
                            <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#photo" type="button"
                                role="tab">
                                <i class="fa fa-camera me-2"></i>Photo
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#video" type="button"
                                role="tab">
                                <i class="fa fa-video-camera me-2"></i>Video
                            </button>
                        </li>
                    </ul>
                </ng-container>
                <!-- Product Images -->
                <div
                    [ngClass]="productOptions?.length > 0 && isSkuActive ? 'col-12 col-lg-6 col-xl-5' : 'col-12 col-lg-6 col-xl-5'">
                    <!-- Mobile Info -->
                    <div class="d-lg-none ps-1">
                        <!-- mobile check fitment -->
                        <div class="mb-2" *ngIf="vehicleName && (productFitToMMY || productData.is_universal == 1)">
                            <i class="fa-solid fa-circle-check icon-blue-checked"></i>
                            <ng-container *ngIf="productData.is_universal == 0 && productFitToMMY">
                                <span class="ps-2">This Product Fit Your {{ vehicleName }}</span>
                                <div class="in-stock txt-vehicle cursor-pointer" (click)="clearVehicle()">
                                    Clear Vehicle
                                </div>
                            </ng-container>
                            <span class="ps-2" *ngIf="productData.is_universal == 1">This Is A Universal Product</span>
                        </div>
                        <div class="d-flex check-wrap mb-2 flex-wrap" *ngIf="vehicleName && !productFitToMMY && productData.is_universal == 0">
                            <i class="fa-solid fa-times-circle icon-red-cross"></i>
                            <span class="ps-2">This Product Does Not Fit Your {{ vehicleName }}</span>
                            <div class="in-stock txt-vehicle cursor-pointer" (click)="clearVehicle()">
                                Clear Vehicle
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div>
                                <h1 class="mb-1 d-lg-none mob-title" [title]="productName">
                                    {{ productName }}
                                </h1>
                            </div>
                            <div *ngIf="corporateCustomer === 'true'">
                                <a class="admin-product-link" (click)="openProductAdmin(product_key)"
                                    [title]="merchantProductUrl + product_key">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </div>
                        </div>
                        <p *ngIf="!hideSubtitle" [innerHTML]="productSubtitle | truncateHtml:45"></p>
                        <div class="d-inline d-md-flex align-items-center gap-md-1 part-name py-2">
                            <ng-container *ngIf="isSkuActive && isOptionSelected; else noOptionPrice">
                                <span class="me-3">Part# {{ selectedFinalSkuString }}</span><span *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</span>
                            </ng-container>
                            <ng-template #noOptionPrice>
                                <span class="me-1" *ngIf="isSkuActive">Part# {{ selectedSku }}</span><span *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</span>
                            </ng-template>
                            <div class="d-flex align-items-center">
                            <div class="rating me-2" (click)="scrollTo('review')">
                                <ng-container *ngIf="(avgRating | starpipe:'fullStar') > 0">
                                    <ng-container *ngFor="let fullstar of (avgRating | starpipe:'fullStar': true)">
                                        <i class="fas fa-star star full fullStar fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(avgRating | starpipe:'halfStar') > 0">
                                    <ng-container *ngFor="let halfstar of (avgRating | starpipe:'halfStar': true)">
                                        <i class="fas fa-star-half-alt half-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(avgRating | starpipe:'noStar') > 0">
                                    <ng-container *ngFor="let noStar of (avgRating | starpipe:'noStar': true)">
                                        <i class="fas fa-star star empty grey-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <span class="reviews" *ngIf="reviewsCount > 0" (click)="scrollTo('review')">
                                ({{ reviewsCount }} {{ reviewsCount > 1 ? 'reviews' : 'review' }})
                            </span>
                            <span class="reviews" *ngIf="reviewsCount == 0" (click)="openReviewItPopup()">
                                (Review It)
                            </span>
                            </div>
                        </div>
                        <!--Mobile device images (shown only when no video tab, always visible)-->
                        <ng-container *ngIf="productVideo?.length == 0 && activeImage">
                            <div class="main-image position-relative d-lg-none d-flex mb-3"
                              (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
                                <div class="blue-print-logo">
                                    <img *ngIf="brandLogo" [src]="cdnImagePath + brandLogo" loading="lazy">
                                </div>
                                <ng-container *ngIf="productPromotion">
                                    <div *ngIf="chTheme4" class="discount-txt-usgrid-2 position-absolute top-0 start-0" [ngSwitch]="promotionType">
                                        <ng-container *ngSwitchCase="'percentage_discount'">
                                            {{ promotionDescription }} - {{ promotionDiscount }}% OFF
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'discount_flat_rate'">
                                            {{ promotionDescription }} - ${{ promotionDiscount }} OFF
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <div class="product-thumbanil-main"   (click)="viewSlider(activeIndex)">
                                    <img class="img-fluid product-details-img " [src]="activeImage" alt="Main Product"
                                        [title]="productName" (error)="onImageError($event)" loading="lazy">
                                </div>
                                <ng-container *ngIf="imageObject?.length > 1">
                                    <button class="carousel-control-prev custom-control prev-btn" type="button"
                                        (click)="prevImage(); $event.stopPropagation()">
                                        <span class="carousel-control-prev-icon"></span>
                                    </button>
                                    <button class="carousel-control-next custom-control next-btn" type="button"
                                        (click)="nextImage(); $event.stopPropagation()">
                                        <span class="carousel-control-next-icon"></span>
                                    </button>
                                </ng-container>
                            </div>
                            <div
                                class="d-flex justify-content-between align-items-start px-0 contact-info d-none d-lg-flex mt-3">
                                <div class="d-flex align-items-start">
                                    <div class="pe-2">
                                        <img [src]="commonImagePath+'have_a_question_img.webp'" alt="Support"
                                            loading="lazy">
                                    </div>
                                    <div class="help-desk"  >
                                        <div [innerHtml]="productSpecialistContactInfo | sanitizeHtml"></div>
                                        <p class="contact-num"> {{formatted_contact}}</p>
                                    </div>
                                </div>
                                <div class="social-icons d-flex gap-2" *ngIf="chTheme1">
                                    <a (click)="share('twitter')" class="social-btn">
                                        <img [src]="commonImagePath+'twitter-img.png'" alt="Twitter">
                                    </a>
                                    <a (click)="share('facebook')" class="social-btn">
                                        <img [src]="commonImagePath+'facebook-img.png'" alt="Facebook">
                                    </a>
                                    <a (click)="share('instagram')" class="social-btn">
                                        <img [src]="commonImagePath+'instagram-img.png'" alt="Instagram">
                                    </a>
                                    <a (click)="share('youtube')" class="social-btn">
                                        <img [src]="commonImagePath+'youtube-img.png'" alt="YouTube">
                                    </a>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="productDescription">
                            <p class="mb-4 item-description d-block d-lg-none"
                                [innerHtml]="productDescription | sanitizeHtml"></p>
                        </ng-container>
                    </div>
                    <!-- Tabs Content -->
                    <div class="tab-content">
                        <!-- PHOTO TAB -->
                        <div class="tab-pane fade show active" id="photo" role="tabpanel">
                            <!-- Mobile device images inside tab -->
                            <ng-container *ngIf="productVideo?.length > 0 && activeImage">
                                <div class="main-image position-relative d-lg-none d-flex mb-3"
                                  (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
                                    <div class="blue-print-logo">
                                        <img *ngIf="brandLogo" [src]="cdnImagePath + brandLogo" loading="lazy">
                                    </div>
                                    <ng-container *ngIf="productPromotion">
                                        <div *ngIf="chTheme4" class="discount-txt-usgrid-2 position-absolute top-0 start-0" [ngSwitch]="promotionType">
                                            <ng-container *ngSwitchCase="'percentage_discount'">
                                                {{ promotionDescription }} - {{ promotionDiscount }}% OFF
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'discount_flat_rate'">
                                                {{ promotionDescription }} - ${{ promotionDiscount }} OFF
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                    <div class="product-thumbanil-main" (click)="viewSlider(activeIndex)">
                                        <img class="img-fluid product-details-img" [src]="activeImage" alt="Main Product"
                                            [title]="productName" (error)="onImageError($event)" loading="lazy">
                                    </div>
                                    <ng-container *ngIf="imageObject?.length > 1">
                                        <button class="carousel-control-prev custom-control prev-btn" type="button"
                                            (click)="prevImage(); $event.stopPropagation()">
                                            <span class="carousel-control-prev-icon"></span>
                                        </button>
                                        <button class="carousel-control-next custom-control next-btn" type="button"
                                            (click)="nextImage(); $event.stopPropagation()">
                                            <span class="carousel-control-next-icon"></span>
                                        </button>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <div class="row g-2">
                                <ng-container
                                    *ngIf="imageObject?.length > 1 && (productOptions?.length < 1 || !isSkuActive)">
                                    <!-- Left Thumbnails -->
                                    <div class="col-2 d-none d-lg-block left-block-thumb">
                                        <div class="thumbnail-list">
                                            <ng-container *ngFor="let image of imageObject; let i = index">
                                                <img class="img-fluid thumb" [src]="image.image" alt="Thumbnail"
                                                    [class.active]="i === activeIndex" (click)="selectImage(i)"
                                                    (error)="onImageError($event)" loading="lazy">
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                                <div
                                    [ngClass]="imageObject?.length === 1 || productOptions?.length > 0 && isSkuActive ? 'col-12 col-lg-12' : 'col-12 col-lg-10'">
                                    <!-- Main Image -->
                                    <ng-container *ngIf="activeImage" >
                                        <div class="main-image position-relative d-none d-lg-flex"
                                            (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
                                            <div class="blue-print-logo">
                                                <img *ngIf="brandLogo" [src]="cdnImagePath + brandLogo" loading="lazy">
                                            </div>
                                            <ng-container *ngIf="productPromotion">
                                                <div *ngIf="chTheme4" class="discount-txt-usgrid-2 position-absolute top-0 start-0" [ngSwitch]="promotionType">
                                                    <ng-container *ngSwitchCase="'percentage_discount'">
                                                        {{ promotionDescription }} - {{ promotionDiscount }}% OFF
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'discount_flat_rate'">
                                                        {{ promotionDescription }} - ${{ promotionDiscount }} OFF
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                            <div class="product-thumbanil-main"  (click)="viewSlider(activeIndex)">
                                                <img class="img-fluid product-details-img " [src]="activeImage"
                                                    alt="Main Product" [title]="productName"
                                                    (error)="onImageError($event)" loading="lazy">
                                            </div>
                                            <ng-container *ngIf="imageObject?.length > 1">
                                                <button class="carousel-control-prev custom-control prev-btn"
                                                    type="button" (click)="prevImage(); $event.stopPropagation()">
                                                    <span class="carousel-control-prev-icon"></span>
                                                </button>
                                                <button class="carousel-control-next custom-control next-btn"
                                                    type="button" (click)="nextImage(); $event.stopPropagation()">
                                                    <span class="carousel-control-next-icon"></span>
                                                </button>
                                            </ng-container>
                                        </div>                                       
                                    </ng-container>
                                </div>
                            </div>                            
                        </div>
                        <!-- VIDEO TAB -->
                        <div class="tab-pane fade" id="video" role="tabpanel">
                            <div class=" main-image position-relative">
                                <div class="product-thumbanil-main">
                                    <div [innerHTML]="sanitizedEmbedCode[activeVideo]"></div>
                                </div>
                                <ng-container *ngIf="sanitizedEmbedCode?.length > 1">
                                    <button class="carousel-control-prev custom-control prev-btn" type="button"
                                        (click)="prevVideo()">
                                        <span class="carousel-control-prev-icon"></span>
                                    </button>
                                    <button class="carousel-control-next custom-control next-btn" type="button"
                                        (click)="nextVideo()">
                                        <span class="carousel-control-next-icon"></span>
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-start px-0 contact-info d-none d-lg-flex mt-3">
                            <div class="d-flex align-items-start">
                                <div class="pe-2">
                                    <img [src]="commonImagePath+'have_a_question_img.webp'" alt="Support" loading="lazy">
                                </div>
                                <div class="help-desk">
                                    <div [innerHtml]="productSpecialistContactInfo | sanitizeHtml"></div>
                                    <p class="contact-num"> {{formatted_contact}}</p>
                                </div>
                            </div>
                            <div class="social-icons d-flex gap-2" *ngIf="chTheme1">
                                <a (click)="share('twitter')" class="social-btn">
                                    <img [src]="commonImagePath+'twitter-img.png'" alt="Twitter">
                                </a>
                                <a (click)="share('facebook')" class="social-btn">
                                    <img [src]="commonImagePath+'facebook-img.png'" alt="Facebook">
                                </a>
                                <a (click)="share('instagram')" class="social-btn">
                                    <img [src]="commonImagePath+'instagram-img.png'" alt="Instagram">
                                </a>
                                <a (click)="share('youtube')" class="social-btn">
                                    <img [src]="commonImagePath+'youtube-img.png'" alt="YouTube">
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- Single Gallery Slider for both mobile and desktop -->
                    <div class="gallery-slider" *ngIf="showImagePopup" (click)="closeImagePopup()">
                        <button *ngIf="imageObject?.length > 1" type="button" class="col-2 ms-2" (click)="prevPopupImage(); $event.stopPropagation()">
                            <i class="fa fa-angle-left text-white"></i>
                        </button>
                        <div class="col-10 col-md-10 position-relative">
                            <div class="d-flex justify-content-end white-close-product mb-1">
                                <div type="button" (click)="closeImagePopup();$event.stopPropagation()">
                                    <i class="fa fa-close text-white"></i>
                                </div>
                            </div>
                            <div class="gallery-image-wrapper d-flex justify-content-center flex-column">
                                <img class="gallery-img img-fluid" [src]="imageObject[popupActiveIndex]?.image"
                                    [alt]="productName" (error)="onImageError($event)" (click)="nextPopupImage();$event.stopPropagation()" loading="lazy">
                              <div>
                                    <div class="row justify-content-between justify-content-md-center gap-xxl-4 pagination-cont">
                                        <div class="col-7 col-lg-3 col-xl-3 col-xxl-5 text-white img-product-nme text-start text-xxl-start">{{productName}}</div>
                                        <div class="col-3 col-lg-2 col-xl-2 col-xxl-1 text-white product-pge text-end">{{ popupActiveIndex + 1 }} of {{ imageObject?.length }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button *ngIf="imageObject?.length > 1" class="col-2 me-2" type="button" (click)="nextPopupImage(); $event.stopPropagation()">
                            <i class="fa fa-angle-right text-white"></i>
                        </button>
                    </div>
                </div>
                <!-- Product Details -->
                <div
                    [ngClass]="productOptions?.length > 0 && isSkuActive ? 'col-12 col-lg-4 mt-3 mt-lg-0 mt-md-0 product-details' : 'col-12 col-lg-6 col-xl-7 mt-3 mt-lg-0 mt-md-0 product-details'">
                    <div class="p_i_zoom">
                        <div class="detail"></div>
                    </div>
                    <!-- laptop checkfitment  -->
                    <div class="d-flex check-wrap mb-2 d-none d-md-flex align-items-center"
                        *ngIf="vehicleName && (productFitToMMY || productData.is_universal == 1)">
                        <i class="fa-solid fa-circle-check icon-blue-checked"></i>
                        <ng-container *ngIf="productData.is_universal == 0 && productFitToMMY">
                            <p class="ps-2">
                                This Product Fits Your {{ vehicleName }}
                            </p>
                            <p class="in-stock txt-vehicle ps-2 cursor-pointer" (click)="clearVehicle()">
                                Clear Vehicle
                            </p>
                        </ng-container>
                        <p class="ps-2" *ngIf="productData.is_universal == 1">
                            This Is A Universal Product
                        </p>
                    </div>
                    <div class="d-flex check-wrap mb-2 2 d-none d-md-flex align-items-center"
                        *ngIf="vehicleName && !productFitToMMY && productData.is_universal == 0">
                        <i class="fa-solid fa-times-circle icon-red-cross"></i>
                        <p class="ps-3">
                             Does Not Fit Your {{ vehicleName }}
                        </p>
                        <p class="in-stock txt-vehicle ps-2 cursor-pointer" (click)="clearVehicle()">
                            Clear Vehicle
                        </p>
                    </div>
                    <!-- Title -->
                    <div class="d-flex align-items-center">
                        <div>
                            <h1 class="mb-1 d-none d-lg-block part-detail-title" [title]="productName">
                                {{ productName }}
                            </h1>
                        </div>
                        <div *ngIf="corporateCustomer === 'true'">
                        <a class="admin-product-link" (click)="openProductAdmin(product_key)"
                            [title]="merchantProductUrl + product_key">
                            <i class="fa fa-eye"></i>
                        </a>
                        </div>
                    </div>
                    <p *ngIf="!hideSubtitle" [innerHTML]="productSubtitle | truncateHtml:100"
                        class="d-none d-md-block prod-sub"></p>
                    <div class="d-none d-lg-block prod-sku-cont">
                        <ng-container *ngIf="isSkuActive && isOptionSelected; else noOptionPrice">
                            <p class="mb-0">Part# {{ selectedFinalSkuString }}</p><p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                        </ng-container>
                        <ng-template #noOptionPrice>
                            <p class="mb-0" *ngIf="isSkuActive">Part# {{ selectedSku }}</p><p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                        </ng-template>
                    </div>
                    <!-- Rating -->
                    <div class="d-flex flex-wrap justify-content-between d-none d-lg-block">
                        <a class="tab-reviews">
                            <div class="kalles-rating-result" (click)="scrollTo('review')">
                                <span class="kalles-rating-result__pipe">
                                    <ng-container *ngIf="(avgRating | starpipe:'fullStar') > 0">
                                        <ng-container *ngFor="let fullstar of (avgRating | starpipe:'fullStar': true)">
                                            <i class="fas fa-star star full fullStar fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(avgRating | starpipe:'halfStar') > 0">
                                        <ng-container *ngFor="let halfstar of (avgRating | starpipe:'halfStar': true)">
                                            <i class="fas fa-star-half-alt half-star fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(avgRating | starpipe:'noStar') > 0">
                                        <ng-container *ngFor="let noStar of (avgRating | starpipe:'noStar': true)">
                                            <i class="fas fa-star star empty grey-star fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                </span>
                                <a *ngIf="reviewsCount > 0">({{ reviewsCount }} {{ reviewsCount > 1 ? 'reviews' :
                                    'review' }})</a>
                                <a *ngIf="reviewsCount == 0" (click)="openReviewItPopup()">(Review It)</a>
                            </div>
                        </a>
                    </div>
                    <!-- Description -->
                    <ng-container *ngIf="productDescription">
                        <p class="mb-3 item-description mt-2 d-none d-lg-block"
                            [innerHtml]="productDescription | sanitizeHtml "></p>
                    </ng-container>
                    <!-- Pricing -->
                    <ng-container *ngIf="productPromotion">
                        <p class="discount-title pt-md-3 pt-lg-0" [ngSwitch]="promotionType">
                            <ng-container *ngSwitchCase="'percentage_discount'">
                                {{ promotionDescription }} - {{ promotionDiscount }}% OFF
                            </ng-container>
                            <ng-container *ngSwitchCase="'discount_flat_rate'">
                                {{ promotionDescription }} - ${{ promotionDiscount }} OFF
                            </ng-container>
                        </p>
                    </ng-container>
                    <!-- FULL PRICE SECTION -->
                    <ng-container *ngIf="hasValidPrice">
                        <!-- Case: Option selected + active SKU -->
                        <ng-container *ngIf="(isSkuActive || variationCount === 1) && isOptionSelected; else nonOption">
                            <p class="product-price">
                                {{ selectedFinalPrice | customCurrency }}
                            </p>
                        </ng-container>
                        <!-- Case: No option selected -->
                        <ng-template #nonOption>
                            <!-- Promotion price -->
                            <ng-container
                                *ngIf="(isSkuActive || variationCount === 1) && promotion && !isMapPricingPromo; else singlePrice">
                                <p class="product-price">
                                    {{ promotionalPrice | customCurrency }}
                                </p>
                            </ng-container>
                            <!-- Regular single price -->
                            <ng-template #singlePrice>
                                <ng-container *ngIf="(isSkuActive || variationCount === 1); else priceRange">
                                    <p class="product-price">
                                        {{ selectedSkuPrice | customCurrency }}
                                    </p>
                                </ng-container>
                                <!-- Price range -->
                                <ng-template #priceRange>
                                    <ng-container *ngIf="minPrice !== maxPrice; else samePriceRef">
                                        <p class="product-price">
                                            {{ minPrice | customCurrency }} - {{ maxPrice | customCurrency }}
                                        </p>
                                    </ng-container>
                                    <!-- Same price -->
                                    <ng-template #samePriceRef>
                                        <p class="product-price">
                                            {{ samePrice | customCurrency }}
                                        </p>
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                        <!-- Strike-through -->
                        <ng-container *ngIf="showStrikePrice">
                            <span class="text-decoration-line-through">
                                {{ strikePrice | customCurrency }}
                            </span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="chTheme1; else nokarl">
                        <!-- Stock Info Karl -->
                        <ng-container *ngIf="!inventoryMessages?.showBackorder; else outOfStock">
                            <p class="para-cont-instack mb-0 d-flex flex-column" *ngIf="isSkuActive && !inventoryFlag">
                                <!-- Availability -->
                                <span class="fw-bold">
                                    <span class="text-blue">
                                        {{ inventoryMessages?.availabilityMsg?.split(' ').slice(0, 2).join(' ') }}
                                    </span>
                                    {{ inventoryMessages?.availabilityMsg?.split(' ').slice(2).join(' ') }}
                                </span>
                                <!-- Urgency -->
                                <span class="text-red fw-bold">
                                    {{ inventoryMessages?.urgencyMsg }}
                                </span>
                                <!-- Pickup -->
                                <span class="fw-bold"
                                    *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                    <span class="local-pickup">Local pickup</span>&nbsp;<span
                                        class="fw-normal">not available</span>
                                </span>
                                <ng-template #pickupAvailable1>
                                    <span class="fw-bold" [innerHTML]="getPickupMsgHtml()"></span>
                                </ng-template>
                            </p>
                        </ng-container>
                        <ng-template #outOfStock>
                            <p class="para-cont-instack mb-0 d-flex flex-column">
                                <!-- Availability -->
                                <span class="fw-bold">
                                    {{ inventoryMessages?.availabilityMsg }}
                                </span>
                                <!-- Pickup -->
                                <span class="fw-bold"
                                    *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                    <span class="local-pickup">Local pickup</span>&nbsp;<span
                                        class="fw-normal">not available</span>
                                </span>
                                <ng-template #pickupAvailable1>
                                    <span class="fw-bold" [innerHTML]="getPickupMsgHtml()"></span>
                                </ng-template>
                            </p>
                        </ng-template>
                    </ng-container>
                    <ng-template #nokarl>
                        <!-- Stock Info Other -->
                        <ng-container *ngIf="isSkuActive && !inventoryFlag">
                            <p class="para-cont-instack">
                                <span [class.in-stock]="isSelectedSkuInventoryAvailable"
                                    [class.out-of-stock]="!isSelectedSkuInventoryAvailable">
                                    <ng-container *ngIf="isSelectedSkuInventoryAvailable; else outOfStock">
                                        In Stock</ng-container>
                                    <ng-template #outOfStock>Call For Availability
                                        <a [href]="'tel:' + contact" class="text-danger">
                                            {{formatted_contact}}
                                        </a>
                                    </ng-template>
                                </span>
                                <ng-container *ngIf="inventoryQty > 10; else lessThan10">
                                    <span *ngIf="isSelectedSkuInventoryAvailable">
                                        (more than 10 available
                                        <ng-container *ngIf="isShipsToday()"> - ships today</ng-container>)
                                    </span>
                                </ng-container>
                                <ng-template #lessThan10>
                                    <span *ngIf="isSelectedSkuInventoryAvailable">
                                        (only {{inventoryQty}} left, order now
                                        <ng-container *ngIf="isShipsToday()"> - ships today</ng-container>)
                                    </span>
                                </ng-template>
                            </p>
                        </ng-container>
                    </ng-template>
                    <!-- Shipping -->
                    <div class="shipping-info">
                        <ng-container *ngIf="isFreeShipping">
                            <div class="free-shipping">
                                <img [src]="commonImagePath + 'freeshipping_red_icon.webp'" alt="Free Shipping"
                                    class="pe-2 mb-2" loading="lazy">
                                <span>Free Shipping</span>
                            </div>
                        </ng-container>
                        <p class="mt-2 mt-md-3 in-stock cursor-pointer d-flex flex-wrap align-items-center">
                            <ng-container *ngFor="let item of links; let i = index; let last = last">
                                <span (click)="handleClick(item)" [ngClass]="i === 0 ? 'pe-0' : 'px-1'">
                                    {{ item.label }}
                                </span>
                                <span *ngIf="!last && item.show" class="text-secondary">|</span>
                            </ng-container>
                        </p>
                    </div>
                    <!-- Product Options -->
                    <ng-container *ngIf="isSize || isColor">
                        <app-product-color-size [productColor]="productColor" [productSize]="productSize"
                            [selectedColorKey]="selectedColorKey" [selectedSizeKey]="selectedSizeKey"
                            [availableColors]="availableColors" [availableSizes]="availableSizes"
                            (colorChange)="onSelectColor($event)" (sizeChange)="onSelectSize($event)">
                        </app-product-color-size>
                    </ng-container>
                    <!-- Payment Info -->
                    <div class="aff-details-h mt-3" *ngIf="isAffirm || isPaypal">
                        <small *ngIf="isAffirm">
                            <app-affirm-widget [amount]="affirmPriceCents"></app-affirm-widget>
                        </small>
                        <small *ngIf="isPaypal">
                            <app-paypal-widget [amount]="paypalPrice" [clientId]="paypalClientId"></app-paypal-widget>
                        </small>
                    </div>
                    <ng-container *ngIf="!inventoryFlag; else globInv">
                        <!-- Add to Cart -->
                        <ng-container *ngIf="((isSkuActive || variationCount == 1) && isSelectedSkuInventoryAvailable)">
                            <ng-container *ngIf="hasValidPrice; else contactusBtn">
                                <ng-container *ngIf="addToCartFlag">
                                    <button *ngIf="(showAddToCartButton && isSelectedSkuInventoryAvailable)" data-bs-toggle="offcanvas"
                                        class="btn btn-teal text-uppercase  min-w-150 btn-add-to-cart mt-2" (click)="onAddToCart()">
                                        Add to Cart
                                    </button>
                                    <button *ngIf="showCheckoutButton && isSelectedSkuInventoryAvailable" data-bs-toggle="offcanvas"
                                        class="btn btn-teal text-uppercase  min-w-150 btn-add-to-cart mt-2" [routerLink]="['/cart']"
                                        [disabled]="disableCheckoutButton">
                                        Checkout Now
                                    </button>
                                </ng-container>
                            </ng-container>
                            <ng-template #contactusBtn>
                                <button
                                    class="btn btn-teal text-uppercase place-backorder min-w-150 btn-add-to-cart mt-2"
                                    (click)="onContactClick(productName)">
                                    CONTACT US FOR BEST PRICING
                                </button>
                            </ng-template>
                        </ng-container>
                        <!-- Place Backorder -->
                        <ng-container
                            *ngIf="((isSkuActive || variationCount == 1) && !isSelectedSkuInventoryAvailable)">
                            <div class="notify-container">
                                <p class="notify-title mt-3">
                                    Notify me when this product is available or place backorder:
                                </p>
                                <form [formGroup]="notifyForm" (ngSubmit)="onNotifySubmit()">
                                    <div class="notify-form mt-2 mb-3">
                                        <input type="email" class="notify-input" placeholder="Email address"
                                            formControlName="email" />
                                        <button class="notify-btn" type="submit">Email me</button>
                                    </div>
                                </form>
                                <div class="error-msg" *ngIf="notifyErrorMessage">
                                    {{ notifyErrorMessage }}
                                </div>
                            </div>
                            <ng-container *ngIf="hasValidPrice; else contactusBtn">
                                <button *ngIf="(showAddToCartButton && !isSelectedSkuInventoryAvailable)"
                                    class="btn btn-teal text-uppercase place-backorder-1 min-w-150 btn-add-to-cart mt-2"
                                    (click)="onAddToCart()">
                                    Place Backorder
                                </button>
                                <button *ngIf="showCheckoutButton && !isSelectedSkuInventoryAvailable"
                                    class="btn btn-teal text-uppercase place-backorder min-w-150 btn-add-to-cart mt-2"
                                    (click)="onAddToCart()">
                                    Checkout Now
                                </button>
                            </ng-container>
                            <ng-template #contactusBtn>
                                <button
                                    class="btn btn-teal text-uppercase place-backorder min-w-150 btn-add-to-cart mt-2"
                                    (click)="onContactClick(productName)">
                                    CONTACT US FOR BEST PRICING
                                </button>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                    <ng-template #globInv>
                        <ng-container *ngIf="isSkuActive || variationCount == 1">
                            <ng-container *ngIf="hasValidPrice; else contactusBtn">
                                <ng-container *ngIf="addToCartFlag">
                                    <button *ngIf="showAddToCartButton" data-bs-toggle="offcanvas"
                                        class="btn btn-teal text-uppercase  min-w-150 btn-add-to-cart mt-2" (click)="onAddToCart()">
                                        Add to Cart
                                    </button>
                                    <button *ngIf="showCheckoutButton" data-bs-toggle="offcanvas"
                                        class="btn btn-teal text-uppercase  min-w-150 btn-add-to-cart mt-2" [routerLink]="['/cart']"
                                        [disabled]="disableCheckoutButton">
                                        Checkout Now
                                    </button>
                                </ng-container>
                            </ng-container>
                            <ng-template #contactusBtn>
                                <button
                                    class="btn btn-teal text-uppercase place-backorder min-w-150 btn-add-to-cart mt-2"
                                    (click)="onContactClick(productName)">
                                    CONTACT US FOR BEST PRICING
                                </button>
                            </ng-template>
                        </ng-container>
                    </ng-template>
                    <button *ngIf="productFitToMMY && !this.vehicleName" data-bs-toggle="offcanvas"
                        class="btn btn-teal text-uppercase  min-w-150 verify-cart mt-2 ms-md-2" (click)="openVechicleSearchPopup()">
                        Verify Fitment
                    </button>
                    <!-- Action Icons -->
                    <div class="d-flex gap-3 gap-md-4 pt-3 pt-md-4 px-2 px-md-1 action-icons">
                        <!-- <div class="d-flex align-items-center icon-item">
                            <img [src]="commonImagePath+'check.webp'" alt="Compare" class="icon-img" loading="lazy">
                            <span class="icon-text">Compare</span>
                        </div> -->
                        <div class="d-flex align-items-center icon-item" (click)="openLoveItPopup()">
                            <img [src]="commonImagePath+'like_img_karls.png'" alt="Like" class="icon-img"
                                loading="lazy">
                        </div>
                        <div class="d-flex align-items-center icon-item" (click)="openWishlist()">
                            <img [src]="commonImagePath+'wishlist_img.png'" alt="Wishlist" class="icon-img"
                                loading="lazy">
                            <span class="icon-text"></span>
                        </div>
                        <div class="d-flex align-items-center icon-item" (click)="downloadInstruction()"
                            *ngIf="instructionsData?.length > 0">
                            <img [src]="commonImagePath +'instruction_img.webp'" alt="Instructions" class="icon-img"
                                loading="lazy">
                            <span class="icon-text">Instructions</span>
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-center  justify-content-md-between align-items-md-start pt-5 px-0 contact-info d-lg-none mb-3">
                        <!-- Contact Support -->
                        <div class="d-flex align-items-start">
                            <div class="pe-2">
                                <img [src]="commonImagePath+'have_a_question_img.webp'" alt="Support" loading="lazy">
                            </div>
                            <div class="help-desk">
                                        <div [innerHtml]="productSpecialistContactInfo | sanitizeHtml"></div>
                                        <p class="contact-num d-none d-md-block"> {{formatted_contact}}</p>
                            </div>
                        </div>
                        <!-- Social Media Icons -->
                        <div class="social-icons d-flex justify-content-center mt-4 mt-md-3 mb-4" *ngIf="chTheme1">
                            <a (click)="share('twitter')" class="social-btn" role="button">
                                <img [src]="commonImagePath+'twitter-img.png'" alt="Twitter" loading="lazy">
                            </a>
                            <a (click)="share('facebook')" class="social-btn" role="button">
                                <img [src]="commonImagePath+'facebook-img.png'" alt="Facebook" loading="lazy">
                            </a>
                            <a (click)="share('instagram')" class="social-btn" role="button">
                                <img [src]="commonImagePath+'instagram-img.png'" alt="Instagram" loading="lazy">
                            </a>
                            <a (click)="share('youtube')" class="social-btn" role="button">
                                <img [src]="commonImagePath+'youtube-img.png'" alt="YouTube" loading="lazy">
                            </a>
                        </div>
                    </div>
                    <div>
                        <!-- Warning Button -->
                        <ng-container *ngIf="warningMessage === 1">
                            <div class="warning-warp">
                                <a href='https://www.P65Warnings.ca.gov' class="warning-btn" target="_blank">
                                    <img [src]="commonImagePath+'p65_warnings_icon.png'" loading="lazy">
                                    <span><strong>Warning:</strong> Cancer and Reproductive Harm -
                                        www.P65Warnings.ca.gov</span>
                                </a>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ng-container *ngIf="productOptions?.length > 0 && isOption && isSkuActive">
                    <div class="col-12 col-lg-3">
                        <app-product-option *ngIf="productOptionsLoaded" [productOptions]="productOptions"
                            [selectedProductVariationKey]="selectedProductVariationKey"
                            (sendOptionsDataEvent)="onSelectOptions($event)"
                            (productReplacementEvent)="onSelectProductReplacement($event)" />
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- We need this div on second phase do not delete it
            <div class="container-fluid">
                <ng-container *ngIf="showRelatedProducts && relatedProducts?.length > 0">
                    <app-customers-bought [relatedProducts]="relatedProducts"></app-customers-bought>
                </ng-container>
            </div> -->
    </section>
    <!-- sticky header html -->
    <div class="part-sticky" [ngClass]="{'sticky-visible': isStickyVisible}" id="productSticky">
        <section class="sticky-header-section">
            <div class="container product-header px-md-0 px-3">
                <div class="row d-block d-md-none">
                    <p class="product-heading" [title]="productName">
                        {{ productName?.length > 80 ? (productName | slice:0:80) + '...' : productName }}
                    </p>
                </div>
                <div class="row align-items-end align-items-md-center">
                    <!-- LEFT: col-6 -> product image + title + rating + ship info (kept original inner classes) -->
                    <div class="col-6 col-md-7 col-lg-6 d-flex align-items-center p-0">
                        <!-- Title + sku + rating + shipping (kept inner markup & classes exactly) -->
                        <div class="me-0 me-md-4 product-header-cont">
                            <h1 class="product-heading d-none d-md-flex" [title]="productName">
                                {{ productName?.length > 50 ? (productName | slice:0:50) + '...' : productName }}
                            </h1>
                            <div class="kalles-rating-results d-flex align-items-center">
                                <!-- Review stars -->
                                <div role="img" class="review-stars d-flex me-1 d-none">
                                    <ng-container *ngIf="(avgRating | starpipe:'fullStar') > 0">
                                        <ng-container *ngFor="let fullstar of (avgRating | starpipe:'fullStar': true)">
                                            <i class="fas fa-star star full fullStarSticky fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(avgRating | starpipe:'halfStar') > 0">
                                        <ng-container *ngFor="let halfstar of (avgRating | starpipe:'halfStar': true)">
                                            <i class="fas fa-star-half-alt half-star-sticky fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(avgRating | starpipe:'noStar') > 0">
                                        <ng-container *ngFor="let noStar of (avgRating | starpipe:'noStar': true)">
                                            <i class="fas fa-star star empty grey-star-sticky fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <!-- Reviews -->
                                <a class="me-1 d-none">
                                    ({{ reviewsCount }} {{ reviewsCount > 1 ? 'reviews' : 'review'}})
                                </a>
                                <!-- Part Number (kept classes) -->
                                <div class="d-none d-md-block">
                                    <ng-container *ngIf="isSkuActive && isOptionSelected; else noOptionPrice">
                                        <p class="part-sku mb-0 me-2">Part# {{ selectedFinalSkuString }}</p>
                                        <p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                                    </ng-container>
                                    <ng-template #noOptionPrice>
                                        <p class="part-sku mb-0 me-2" *ngIf="isSkuActive">Part# {{ selectedSku }}</p>
                                        <p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="d-block d-md-none">
                                <ng-container *ngIf="isSkuActive && isOptionSelected; else noOptionPrice">
                                    <p class="part-sku mb-0">Part# {{ selectedFinalSkuString }}</p>
                                    <p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                                </ng-container>
                                <ng-template #noOptionPrice>
                                    <p class="part-sku mb-0" *ngIf="isSkuActive">Part# {{ selectedSku }}</p>
                                    <p *ngIf="isSkuActive && skuData.upc_code">| UPC {{skuData.upc_code}}</p>
                                </ng-template>
                                <p class="mob-price" *ngIf="hasValidPrice">{{ getDisplayedPrice() | customCurrency }}
                                </p>
                            </div>
                        </div>
                        <img class="product-image" [src]="imageObject[0]?.image" alt="product" [title]="productName"
                            (error)="onImageError($event)" loading="lazy">
                    </div>
                    <!-- RIGHT: col-6 -> price + add-to-cart (kept inner classes exactly) -->
                    <div class="col-6 col-md-5 col-lg-6">
                        <div class=" d-flex justify-content-start justify-content-md-end align-items-center ">
                            <div class="text-end d-flex align-items-center">
                                <p class="price fw-bold d-none d-md-block text-center">
                                    <ng-container *ngIf="hasValidPrice">
                                        {{ getDisplayedPrice() | customCurrency }}
                                    </ng-container>
                                    <ng-container *ngIf="isSelectedSkuInventoryAvailable && inventoryQty > 10">
                                        <span class="ship-date d-block">
                                            <strong class="ship-label">Estimated Ship Date:</strong>
                                            <span class="ship-date-info ms-1">Today</span>
                                        </span>
                                    </ng-container>
                                </p>
                                <ng-container *ngIf="isSkuActive; else multipleSku">
                                    <ng-container *ngIf="hasValidPrice; else contactusBtn">
                                        <ng-container *ngIf="addToCartFlag">
                                            <button class="btn btn-sm add-to-cart"
                                                *ngIf="(showAddToCartButton && (inventoryFlag || isSelectedSkuInventoryAvailable))" (click)="onAddToCart()">
                                                Add To Cart
                                            </button>
                                            <button class="btn btn-sm back-order-btn place-back"
                                                *ngIf="(showAddToCartButton && (!inventoryFlag && !isSelectedSkuInventoryAvailable))"
                                                (click)="onAddToCart()">
                                                Place Backorder
                                            </button>
                                            <button class="btn btn-sm add-to-cart" *ngIf="showCheckoutButton" [routerLink]="['/cart']"
                                                [disabled]="disableCheckoutButton">
                                                Checkout Now
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #contactusBtn>
                                        <button class="btn btn-sm back-order place-back"
                                            (click)="onContactClick(productName)">
                                            CONTACT US FOR BEST PRICING
                                        </button>
                                    </ng-template>
                                </ng-container>
                                <ng-template #multipleSku>
                                    <button class="btn btn-sm back-order" (click)="scrollTo('applications')">
                                        View Products
                                    </button>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Sticky Tabs -->
        <div id="stickyTabsNav" class="sticky-tabs">
            <div class="container">
                <nav class="nav nav-pills justify-content-start justify-content-md-center">
                    <!-- Back to Results Button -->
                    <a class="nav-link back-btn d-block d-lg-none" (click)="goBack()">
                        &lt; Back to Results
                    </a>
                    <!-- Check Fitment -->
                    <ng-container *ngIf="hasFitmentData">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'fitment'}"
                            (click)="selectTab('fitment'); scrollTo('fitment')">
                            Check Fitment
                        </a>
                    </ng-container>
                    <!-- Specification -->
                    <ng-container *ngIf="selectedSkuSpecifications?.length > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'specification'}"
                            (click)="selectTab('specification'); scrollTo('specification')">
                            Specification
                        </a>
                    </ng-container>
                    <!-- Applications -->
                    <ng-container *ngIf="(variationCount > 0 && !isSkuActive) && (showApplicationComponentSetting)">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'applications'}"
                            (click)="selectTab('applications'); scrollTo('applications')">
                            Applications
                        </a>
                    </ng-container>
                    <!-- Instructions -->
                    <ng-container *ngIf="instructionsData?.length > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'instruction'}"
                            (click)="selectTab('instruction'); scrollTo('instruction')">
                            Instructions
                        </a>
                    </ng-container>
                    <!-- Product Resources -->
                    <ng-container *ngIf="productResourcesData?.length > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'productResources'}"
                            (click)="selectTab('productResources'); scrollTo('productResources')">
                            Product Resources
                        </a>
                    </ng-container>
                    <!-- FAQ's -->
                    <ng-container *ngIf="faqsData?.length > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'faq'}"
                            (click)="selectTab('faq'); scrollTo('faq')">
                            FAQ's
                        </a>
                    </ng-container>
                    <!-- Gallery -->
                    <ng-container *ngIf="showGallery">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'gallery'}"
                            (click)="selectTab('gallery'); scrollTo('gallery')">
                            Gallery
                        </a>
                    </ng-container>
                    <!-- Warranty -->
                    <ng-container *ngIf="warrantyData?.length > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'warranty'}"
                            (click)="selectTab('warranty'); scrollTo('warranty')">
                            Warranty
                        </a>
                    </ng-container>
                    <!-- Related Parts -->
                    <ng-container *ngIf="showRelatedProducts">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'relatedProd'}"
                            (click)="selectTab('relatedProd'); scrollTo('relatedProd')">
                            Related Parts
                        </a>
                    </ng-container>
                    <!-- Recently Viewed -->
                    <ng-container *ngIf="showRecentlyViewed">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'recentlyViewed'}"
                            (click)="selectTab('recentlyViewed'); scrollTo('recentlyViewed')">
                            Recently Viewed
                        </a>
                    </ng-container>
                    <!-- Reviews -->
                    <ng-container *ngIf="reviewsCount > 0">
                        <a class="nav-link cursor-pointer" [ngClass]="{'active': selectedTab === 'review'}"
                            (click)="selectTab('review'); scrollTo('review')">
                            Reviews
                        </a>
                    </ng-container>
                </nav>
            </div>
        </div>
    </div>
    <div class="main-project-section container-padding">
        <div class="container">
            <div class="part-tab py-lg-4 pb-3" #partTab>
                <ul class="nav tab_header justify-content-center" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation" *ngIf="hasFitmentData">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'fitment' }"
                            (click)="selectTab('fitment'); scrollTo('fitment')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'fitment'">
                            Check Fitment
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="selectedSkuSpecifications?.length > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'specification' }"
                            (click)="selectTab('specification'); scrollTo('specification')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'specification'">
                            Specification
                        </button>
                    </li>
                    <li class="nav-item" role="presentation"
                        *ngIf="(variationCount > 0 && !isSkuActive) && showApplicationComponentSetting">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'applications' }"
                            (click)="selectTab('applications'); scrollTo('applications')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'applications'">
                            Application
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="instructionsData?.length > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'instruction' }"
                            (click)="selectTab('instruction'); scrollTo('instruction')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'instruction'">
                            Instructions
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="productResourcesData?.length > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'productResources' }"
                            (click)="selectTab('productResources'); scrollTo('productResources')" type="button"
                            role="tab" [attr.aria-selected]="selectedTab === 'productResources'">
                            Product Resources
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="faqsData?.length > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'faq' }" (click)="selectTab('faq'); scrollTo('faq')"
                            type="button" role="tab" [attr.aria-selected]="selectedTab === 'faq'">
                            FAQ's
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="showGallery">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'gallery' }"
                            (click)="selectTab('gallery'); scrollTo('gallery')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'gallery'">
                            Gallery
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="warrantyData?.length > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'warranty' }"
                            (click)="selectTab('warranty'); scrollTo('warranty')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'warranty'">
                            Warranty
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="showRelatedProducts">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'relatedProd' }"
                            (click)="selectTab('relatedProd'); scrollTo('relatedProd')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'relatedProd'">
                            Related Parts
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="showRecentlyViewed">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'recentlyViewed' }"
                            (click)="selectTab('recentlyViewed'); scrollTo('recentlyViewed')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'recentlyViewed'">
                            Recently Viewed
                        </button>
                    </li>
                    <li class="nav-item" role="presentation" *ngIf="reviewsCount > 0">
                        <button class="nav-link cursor-pointer tab-radius pill-border fw-medium"
                            [ngClass]="{ 'active': selectedTab === 'review' }"
                            (click)="selectTab('review'); scrollTo('review')" type="button" role="tab"
                            [attr.aria-selected]="selectedTab === 'review'">
                            Reviews
                        </button>
                    </li>
                </ul>
            </div>
            <!-- Check Fitment -->
            <section id="fitment" #checkFitmentTab [ngStyle]="{'margin-top.px': sectionMargins['checkFitmentTab']}">
                <app-check-fitment *ngIf="hasFitmentData" [fitmentData]="fitmentResponse">
                </app-check-fitment>
            </section>
            <!-- Specification -->
            <section id="specification" #specificationTab
                [ngStyle]="{'margin-top.px': sectionMargins['specificationTab']}">
                <app-product-specifications *ngIf="selectedSkuSpecifications?.length > 0"
                    [selectedSkuSpecifications]="selectedSkuSpecifications">
                </app-product-specifications>
            </section>
            <!-- Applications -->
            <section id="applications" #applicationsTab
                [ngStyle]="{'margin-top.px': sectionMargins['applicationsTab']}">
                <app-application *ngIf="variationCount > 1  && showApplicationComponentSetting"
                    [product_key]="product_key" [productName]="productName" [selectedColorKey]="selectedColorKey"
                    [selectedSizeKey]="selectedSizeKey" [variationCount]="variationCount"
                    [selectedProductVariationKey]="selectedProductVariationKey" [productPromotion]="productPromotion"
                    [disableCheckoutButton]="disableCheckoutButton"
                    (disdisableCheckoutButtonEvent)="getDisabledButton($event)"
                    (sendSingleVariationDataEvent)="getSingleVariationPrices($event)"
                    (sendSamePriceEvent)="getSamePrice($event)" [productFitToMMY]="productFitToMMY">
                </app-application>
            </section>
            <!-- Long Description -->
            <div class="container-fluid">
                <div class="long-discription px-lg-5 py-md-4 " [innerHtml]="productDetailsInfoData  | sanitizeHtml">
                </div>
            </div>
            <!-- Instructions -->
            <section id="instruction" #instructionsTab *ngIf="instructionsData?.length > 0"
                [ngStyle]="{'margin-top.px': sectionMargins['instructionsTab']}">
                <app-instructions [instructionsData]="instructionsData">
                </app-instructions>
            </section>
            <!-- Product Resources -->
            <section id="productResources" #productResourcesTab *ngIf="productResourcesData?.length > 0"
                [ngStyle]="{'margin-top.px': sectionMargins['productResourcesTab']}">
                <app-product-resources [productResourcesData]="productResourcesData">
                </app-product-resources>
            </section>
            <!-- FAQ's -->
            <section id="faq" #faqsTab *ngIf="faqsData?.length > 0"
                [ngStyle]="{'margin-top.px': sectionMargins['faqsTab']}">
                <app-faqs [faqsData]="faqsData">
                </app-faqs>
            </section>
        </div>
        <div class="container-fluid">
            <!-- Gallery -->
            <section id="gallery" #gallaryPhotosTab [ngStyle]="{'margin-top.px': sectionMargins['gallaryPhotosTab']}">
                <app-gallary-photos (galleryStatus)="onGalleryStatus($event)">
                </app-gallary-photos>
            </section>
            <!-- Warranty -->
            <section id="warranty" #warrantyTab [ngStyle]="{'margin-top.px': sectionMargins['warrantyTab']}">
                <app-warranty *ngIf="warrantyData?.length > 0" [warrantyData]="warrantyData">
                </app-warranty>
            </section>
            <!-- Related Parts -->
            <section id="relatedProd" #relatedProductsTab
                [ngStyle]="{'margin-top.px': sectionMargins['relatedProductsTab']}" *ngIf="product_key">
                <app-related-products [productKey]="product_key" (relatedProductData)="onRelatedProductData($event)"
                    (relatedProductStatus)="onRelatedProductStatus($event)">
                </app-related-products>
            </section>
            <!-- Recently Viewed -->
            <section id="recentlyViewed" #recentlyViewedTab
                [ngStyle]="{'margin-top.px': sectionMargins['recentlyViewedTab']}" *ngIf="product_keys">
                <app-recently-viewed [productKeys]="product_keys"
                    (recentlyViewedStatus)="onRecentlyViewedStatus($event)">
                </app-recently-viewed>
            </section>
        </div>
        <div class="container">
            <!-- Reviews -->
            <section id="review" #reviewTab *ngIf="reviewsCount > 0"
                [ngStyle]="{'margin-top.px': sectionMargins['reviewTab']}">
                <app-product-review [productName]="productName" [product_key]="product_key" [imageObject]="imageObject"
                    [productReviews]="productReviews" (totalAverageOutOf5Event)="getTotalAverageOutOf5($event)"
                    (reviewCountEvent)="getTotalReviewsCount($event)">
                </app-product-review>
            </section>
        </div>
    </div>
    <app-subscribe></app-subscribe>
</ng-container>